<div class="DefaultToast__Root">
  @if (prefixIcon) {
    <mat-icon class="DefaultToast__Bookend DefaultToast__Prefix">{{ prefixIcon }}</mat-icon>
  }
  @if (prefixUrl) {
    <img class="DefaultToast__Bookend DefaultToast__Prefix" [src]="prefixUrl" />
  }
  <span class="DefaultToast__Content">{{ content }}</span>
  @if (hasAction) {
    <button
      class="DefaultToast__Bookend DefaultToast__Suffix"
      mat-button
      (click)="action()"
    >{{ actionLabel }}</button>
  } @else {
    <mat-icon
      class="DefaultToast__Bookend DefaultToast__Suffix"
      (click)="dismiss()"
    >close</mat-icon>
  }
</div>